import * as tslib_1 from "tslib";
import { listApi } from "../../../../../../api";
import { DataItemType } from "../../../../../../form/schema";
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { Icon, Input, 
// TreeSelect,
Modal, Radio, Spin, Tooltip, Tree } from "@h3/antd-vue";
import { cloneDeep } from "lodash-es";
import { Component, Prop } from "vue-property-decorator";
import common from "../../../../../../common/pc";
let RelevanceFormModal = class RelevanceFormModal extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.selected = new Array();
        this.query = {};
        this.hover = false;
        this.full = false;
        this.newCol = [];
        this.isClose = false;
        /*
        ***************************树形弹出框数据与逻辑*****************
        */
        this.list = [];
        this.searchTimeoutRef = null;
        this.page = 1;
        this.defaultExpandAll = false;
        this.TreeKey = 0;
        this.searchTitle = '';
        this.spinning = false;
        this.selectedKey = '';
    }
    onChange(e) {
        console.log(e.target.value, "e---------");
        this.searchTitle = e.target.value;
        this.TreeKey = this.TreeKey + 1;
        if (e.target.value === '') {
            this.defaultExpandAll = false;
        }
        else {
            this.defaultExpandAll = true;
        }
        this.onSearch(e.target.value);
    }
    get treeList() {
        if (this.list.length) {
            let arr = [];
            for (let val of this.list) {
                if (val[this.getDisplayField] !== null && val[this.getDisplayField] !== '') {
                    let titles = val[this.getDisplayField];
                    try {
                        //处理地址数据在前台显示异常
                        let parseTitle = JSON.parse(val[this.getDisplayField]) ? JSON.parse(val[this.getDisplayField]) : '';
                        if (parseTitle && parseTitle.valString) {
                            titles = parseTitle.valString;
                        }
                    }
                    catch (_a) { }
                    //人员、部门控件作为树形显示字段时数据格式跟普通数据项不一样
                    if (Array.isArray(titles) && titles.length > 0) {
                        titles = titles.map((titleItem) => {
                            return titleItem['name'];
                        }).join(',');
                    }
                    arr.push({
                        value: val.id,
                        key: val.id,
                        title: titles,
                        children: this.childrenToTreeList(val.t__children_),
                        scopedSlots: { title: 'tree', }
                    });
                }
            }
            console.log(arr);
            return arr;
        }
        else {
            return [];
        }
    }
    //把传过来的关联数据项的子列表做一个清洗，变成符合treeList的数据类型
    childrenToTreeList(children) {
        if (!children)
            return;
        let arr = [];
        for (let i = 0; i < children.length; i++) {
            if (children[i].data[this.getDisplayField]) {
                arr.push({
                    value: children[i].data.id,
                    key: children[i].data.id,
                    title: children[i].data[this.getDisplayField],
                    children: this.childrenToTreeList(children[i].data.t__children_),
                    scopedSlots: { title: 'tree', }
                });
            }
        }
        return arr;
    }
    onselect(selectedKeys, e) {
        console.log(selectedKeys[0]);
        this.selectedKey = selectedKeys[0];
        let arr = this.treeToList(this.list);
        let item = arr.find(x => x.id === selectedKeys[0]);
        this.selected[0] = item;
    }
    onSearch(value) {
        clearTimeout(this.searchTimeoutRef);
        this.searchTimeoutRef = setTimeout(() => {
            this.list = [];
            this.search(value);
        }, 300);
    }
    search(value, page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!page) {
                this.page = 0;
            }
            // this.list = [];
            this.spinning = true;
            let view = {
                type: this.control.options.showStyle === 'tree' ? "TREE" : "LIST",
                depth: this.control.options.showStyle === 'tree' ? 0 : undefined,
                parentRef: this.control.options.showStyle === 'tree' ? "#" : undefined,
            };
            this.fetch(page === undefined ? 0 : page, 1000, value, [], false, view = view).then(seg => {
                if (page) {
                    this.list = [...this.list, ...seg.data];
                }
                else {
                    this.list = seg.data;
                }
                console.log(this.list);
                this.spinning = false;
            }, () => { });
        });
    }
    //树形列表打平查找id
    treeToList(list) {
        if (!list)
            return [];
        let arr = list;
        for (let i = 0; i < list.length; i++) {
            if (list[i].t__children_) {
                arr = [...arr, ...this.treechildToList(list[i].t__children_)];
            }
        }
        return arr;
    }
    //树形子列表打平
    treechildToList(children) {
        if (!children)
            return [];
        let arrList = [];
        for (let i = 0; i < children.length; i++) {
            arrList.push(children[i].data);
            arrList = [...arrList, ...this.treechildToList(children[i].data.t__children_)];
        }
        return arrList;
    }
    /*
    ***************************树形弹出框数据与逻辑*****************
    */
    get text() {
        if (!this.ctrl.value) {
            return "";
        }
        if (!this.ctrl.value[this.getDisplayField]) {
            this.setLinkageValue();
        }
        let val = this.ctrl.value[this.getDisplayField];
        if (val === undefined) {
            val = this.ctrl.value['name'];
        }
        return this.parseDisplayFieldValue(val, this.getDisplayField);
    }
    onClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.control.options.showStyle === 'tree') {
                this.search("");
            }
            this.query = this.getParams();
            if (this.control.options.showField &&
                Array.isArray(this.control.options.showField) &&
                this.control.options.showField.length > 0) {
                let relevanceFormCode = this.control.parentKey
                    ? `${this.control.parentKey}.${this.control.key}`
                    : this.control.key;
                if (this.control.path) {
                    relevanceFormCode = this.control.path.join(".");
                }
                const param = {
                    sheetCode: this.control.options.sheetParams.sheetCode,
                    schemaCode: this.control.options.sheetParams.schemaCode,
                    relevanceFormCode: relevanceFormCode,
                };
                const res = yield listApi.selectFormTitle(param);
                if (res.errcode === 0) {
                    res.data.configBizPropertyList.map((options) => {
                        options.code = options.code === "id" ? "ids" : options.code;
                        options.propertyCode = options.code;
                        options.width = "120";
                        options.childColumns =
                            options.subSchema && options.subSchema.properties;
                        if (options.propertyType === DataItemType.Sheet &&
                            options.childColumns) {
                            options.childColumns = options.childColumns.map((v) => {
                                v.propertyCode = v.code;
                                v.vcTitle = v.name;
                                v.width = "150";
                                return v;
                            });
                        }
                        return options;
                    });
                    this.newCol = res.data.configBizPropertyList;
                    this.visible = true;
                    this.formTitleObj = yield RelevanceFormControl.service.getBizmodelTitle(this.controlOpts.schemaCode || "");
                }
            }
            else {
                this.visible = true;
            }
        });
    }
    get dialogClass() {
        // { 'full-modal': full, 'relevance-form': true }
        if (this.full) {
            return 'full-modal relevance-form';
        }
        else {
            return 'relevance-form';
        }
    }
    onMouseenter() {
        this.hover = true;
    }
    onMouseleave() {
        this.hover = false;
    }
    clear() {
        this.ctrl.value = null;
        this.selected = [];
    }
    onListChange(rows) {
        this.selected = rows;
    }
    fullScreen(full) {
        this.full = full;
        try {
            if (full) {
                // @ts-ignore
                window.parent.window.document.querySelector('.icon-close').style.display = 'none';
            }
            else {
                // @ts-ignore
                window.parent.window.document.querySelector('.icon-close').style.display = 'block';
            }
        }
        catch (error) { }
    }
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log(this.selected[0]);
            this.searchTitle = '';
            let item = yield this.convertForMappings(this.selected[0]);
            this.visible = false;
            if (item) {
                this.interceptorValue(item);
                setTimeout(() => {
                    this.setValue(cloneDeep(item));
                }, 300);
            }
            // this.interceptorValue(item);
            // this.setValue(item);
            // setTimeout(() => {
            //   this.setValue(cloneDeep(item));
            // }, 300);
        });
    }
    onModalCancel() {
        this.visible = false;
        this.full = false;
        this.searchTitle = '';
        this.fullScreen(false);
        if (this.ctrl.value) {
            this.selected = [this.ctrl.value];
        }
        else {
            this.selected = [];
        }
    }
    get isAuthorize() {
        return this.control.options.isAuthorize;
    }
    beforeCreate() {
        const comp = RelevanceFormControl.loadListSelector();
        this.$options.components.ListSelector = comp;
    }
};
tslib_1.__decorate([
    Prop({
        default: {}
    })
], RelevanceFormModal.prototype, "control", void 0);
RelevanceFormModal = tslib_1.__decorate([
    Component({
        name: "relevance-form-modal",
        components: {
            ATooltip: Tooltip,
            AModal: Modal,
            AInput: Input,
            AIcon: Icon,
            ASpin: Spin,
            ARadio: Radio,
            ATree: Tree,
            AInputSearch: Input.Search,
            PageLoading: common.components.PageLoading,
        },
    })
], RelevanceFormModal);
export default RelevanceFormModal;
